<template>
  <div>
    <div class="box" v-for="(item, index) in list" :key="index">
      <div class="title">
        <div class="methodTitle">
          <h3 class="bq">姓名:</h3>
          <h3>{{ item.agent_name ? item.agent_name : '未填写' }}</h3>
        </div>
        <div class="methodTitle">
          <h3 class="bq">手机号:</h3>
          <h3>{{ item.mobile ? item.mobile : '未填写' }}</h3>
        </div>
        <div class="methodSlidebt">
          <ul>
            <li> <h3>上级代理</h3> <p>{{ item.parent_name ? item.parent_name : '无' }}</p> </li>
            <li> <h3>等级</h3> <p>{{ item.user_rank ? item.user_rank : 'V1' }}</p> </li>
            <li> <h3>累计分润</h3> <p>{{ item.total_profit ? item.total_profit : '0' }}</p> </li>
            <li> <h3>账户余额</h3> <p>{{ item.balance ? item.balance : '0' }}</p> </li>
            <li> <h3>团队数量</h3> <p>{{ item.card_quantity ? item.card_quantity : '0' }}</p> </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {
    boxBtn (e) {
      this.$router.push({ name: 'Recharge', params: { iccid: e } })
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style scoped lang='less'>
  [class*=van-hairline]::after {
    border: none;
  }
  .box {
    width: 690px;
    height: 280px;
    background-color: #fff;
    margin: 0 auto 20px;
    box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
    border-radius: 15px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 40px 20px;
    .title {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .methodTitle {
        display: flex;
        justify-content: space-between;
        h3 {
          font-size: 30px;
          color: #272729;
          line-height: 20px;
          font-weight: 400;
        }
        .bq {
          width: 130px;
          text-align: end;
        }
      }
      .methodSlidebt {
        ul {
          display: flex;
          justify-content: space-between;
          height: 70px;
          li {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            h3 {
              line-height: 18px;
              font-size: 25px;
              color: #9D9DA3;
            }
            p {
              line-height: 20px;
              font-size: 25px;
              color: #272729;
            }
          }
        }
      }
    }
    .btn {
      flex: 1;
      text-align: center;
      padding-left: 45px;
      .van-button {
        width: 100px;
      }
    }
  }
  .box:after {
    display: block;
    content: "";
    width: 32px;
    height: 32px;
    background: url(../assets/yans-1.png) no-repeat;
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
  }
</style>
